import { render, staticRenderFns } from "./tableTextPie.vue?vue&type=template&id=9a101b52&scoped=true&"
import script from "./tableTextPie.vue?vue&type=script&lang=ts&"
export * from "./tableTextPie.vue?vue&type=script&lang=ts&"
import style0 from "./tableTextPie.vue?vue&type=style&index=0&id=9a101b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a101b52",
  null
  
)

export default component.exports